export const UPDATE_USER = "UPDATE_USER"
export const UPDATE_USER_ERROR= "UPDATE_USER_ERROR"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGIN_ERROR = "LOGIN_ERROR"
export const SIGN_OUT = "SIGN_OUT"
export const SIGN_UP = "SIGN_UP"
export const SIGN_OUT_ERROR = "SIGN_OUT_ERROR"
export const SIGN_UP_ERROR = "SIGN_UP_ERROR"
export const RESET_PASSWORD = "RESET_PASSWORD"
export const RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR"
export const NEW_PASSWORD = "NEW_PASSWORD"
export const NEW_PASSWORD_ERROR = "NEW_PASSWORD_ERROR"
export const SEND_ENQUIRY = "SEND_ENQUIRY"
export const ADD_MEMBER = "ADD_MEMBER"
export const ADD_MEMBER_ERROR = "ADD_MEMBER_ERROR"
export const DELETE_MEMBER = "DELETE_MEMBER"
export const RESET_ADD_MEMBER = "RESET_ADD_MEMBER"
export const USER_OPTIONS = "USER_OPTIONS"
export const LOGO_UPDATE = "LOGO_UPDATE"
export const ADD_TRAINER = "ADD_TRAINER"
export const ADD_TRAINER_ERROR = "ADD_TRAINER_ERROR"
export const DELETE_TRAINER = "DELETE_TRAINER"